/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Collapse,
  colors,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Link,
  makeStyles,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import {
  Block as BlockIcon,
  CloudDownload as CloudDownloadIcon,
  TableChart as TableChartIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon,
  Info as InfoIcon,
  Error as ErrorIcon,
  OpenInNew as OpenInNewIcon,
  Replay,
  PictureAsPdf,
} from "@material-ui/icons";
import { getBaseURL } from "src/config/api";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import { apiCancelProject } from "src/api";
import { userHasPermission } from "src/components/utils";
import safeLogger from "src/services/safeLogger";
import { format } from "date-fns";
import { connect } from "react-redux";
import Status from "./status";
import { ArrowDown, ArrowUp, File } from "react-feather";
import FailLogs from "./failLogs";
import { DiagnosisMaterialsTable } from "./diagnosisTable";
import {
  apiAcquirePayment,
  apiProjectQuotePrice,
  apiReRunProject,
} from "src/api/endpoints";
import { prepareFiles } from "../reports/utils/helpers";
import { without_credit_projects } from "src/config/credits";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";

const useRowStyles = makeStyles((theme) => ({
  row: {
    cursor: "pointer",
    transition: "all 0.2s  ease-in-out",
    "&:hover": {
      backgroundColor: theme.palette.action.disabledBackground + " ! important",
    },
  },
  completedStatus: {
    // backgroundColor: theme.palette.success.dark,
    border: "1px solid",
    borderColor: theme.palette.success.dark,
    backgroundColor: "#f1f1f1ff",
    fontWeight: 600,
    "& span": {
      color: `${theme.palette.success.dark} !important`,
    },
  },
  analyzingStatus: {
    backgroundColor: theme.palette.warning.light,
    border: "1px solid",
    borderColor: theme.palette.warning.dark,
    fontWeight: 900,
    "& span": {
      color: "white !important",
    },
  },
  errorStatus: {
    border: "1px solid",
    borderColor: theme.palette.error.dark,
    backgroundColor: "#f1f1f1ff",
    fontWeight: 400,
    "& span": {
      color: `${theme.palette.error.dark} !important`,
    },
  },
  cancelledStatus: {
    border: "1px solid",
    borderColor: "#888888",
    backgroundColor: "#f1f1f1ff",
    fontWeight: 700,
    "& span": {
      color: `${theme.palette.info} !important`,
    },
  },
  pendingStatus: {
    border: "1px solid",
    borderColor: "#F7B924",
    backgroundColor: "#f1f1f1ff",
    fontWeight: 600,
    "& span": {
      color: "#F7B924 !important",
    },
  },
  chip: {
    "& span": {
      color: "white !important",
    },
    fontWeight: 900,
  },
  buttonProgress: {
    color: theme.palette.success.main,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  analysisProgress: {
    color: theme.palette.primary.main,
  },
  igvIcon: {
    display: "flex",
    alignItems: "center",
    verticalAlign: "middle",
  },
  info: {
    color: theme.palette.primary.main,
  },
  downloadLink: {
    color: theme.palette.primary.main,
    textDecoration: "underline",
    "&:hover": {
      color: theme.palette.primary.main,
      textDecoration: "underline",
    },
  },
  successChip: {
    backgroundColor: theme.palette.success.light,
    border: "1px solid",
    borderColor: theme.palette.success.dark,
    fontWeight: 900,
    color: "#fff",
    "& .MuiChip-icon": {
      color: "#fff",
    },
  },
  dangerChip: {
    backgroundColor: theme.palette.error.light,
    border: "1px solid",
    borderColor: theme.palette.error.dark,
    fontWeight: 900,
    color: "#fff",
    "& .MuiChip-icon": {
      color: "#fff",
    },
  },
  chipLabelWhite: {
    color: "#fff !important",
  },
  chipIcon: {
    fontSize: 16,
  },
  iconRotate: {
    transition: "transform 0.3s ease-in-out",
    "&:hover": {
      transform: "rotate(-360deg)",
    },
  },
}));

export const CancelAndReAnalysisButton = (props) => {
  const classes = useRowStyles();
  const { type, sampleData, buttonType, projectId, projectData } = props;
  const [dialogOpen, setDialogOpen] = useState(false);
  const [creditTopUp, setCreditTopUp] = useState(0);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  const handleClickOpen = (event) => {
    event.stopPropagation();
    if (
      buttonType === "re" &&
      !without_credit_projects.includes(projectData.project_type)
    ) {
      apiProjectQuotePrice(
        projectId,
        {
          action_type: "rerun",
          project_id: projectId,
          samples: type === "project" ? [] : [sampleData.id],
        },
        (data, status) => {
          if (status === 200) {
            setCreditTopUp(data);
            setDialogOpen(true);
          } else if (status === 409) {
            enqueueSnackbar(
              t("Selected kit is wrong, please contact to Massive admins"),
              {
                variant: "error",
              }
            );
          }
        }
      );
    } else {
      setDialogOpen(true);
    }
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setDialogOpen(false);
  };

  const handleCanel = (event) => {
    if (event) {
      event.stopPropagation();
    }
    setLoading(true);
    apiCancelProject(
      projectId,
      sampleData ? sampleData.id : null,
      (data, status) => {
        safeLogger(data);
        safeLogger(status);
        if (status === 200) {
          setLoading(false);
          // TODO remove project from list if user has no priv to see
          // TODO change status to cancelled to update
          sampleData.status = "cancelled";
          enqueueSnackbar(
            t(
              "analysis_cancelled_message",
              "{{type}} analysis was cancelled!",
              {
                type: type,
              }
            ),
            {
              variant: "warning",
            }
          );
        } else {
          safeLogger(data);
        }
      }
    );
    handleClose(event);
  };

  function re_run(projectId, type, sampleData, data) {
    apiReRunProject(
      projectId,
      type === "project" ? null : [sampleData.id],
      data.payment_id,
      (data, status) => {
        safeLogger(data);
        safeLogger(status);
        if (status === 200) {
          setLoading(false);
          // sampleData.status = "cancelled";
          enqueueSnackbar(
            t("analysis_rerun_message", "{{type}} analysis is starting.", {
              type: t(type.charAt(0).toUpperCase() + type.slice(1)),
            }),
            {
              variant: "success",
            }
          );
          setTimeout(() => {
            window.location.reload();
          }, 800);
        } else if (status === 402) {
          enqueueSnackbar(
            t(
              "Credit not enough for this project, please contact with Massive Analyser team."
            ),
            {
              variant: "error",
            }
          );
        } else {
          safeLogger(data);
        }
      }
    );
  }

  const handleRe = (event) => {
    if (event) {
      event.stopPropagation();
    }
    if (without_credit_projects.includes(projectData.project_type)) {
      re_run(projectId, type, sampleData, {});
    }
    setLoading(true);
    const body = {};

    body["project_id"] = projectId;
    body["quote_id"] = creditTopUp.quote_id;

    apiAcquirePayment(body, (data, status) => {
      if (status === 200) {
        re_run(projectId, type, sampleData, data);
      }
    });
    handleClose(event);
  };

  return (
    <React.Fragment>
      <Tooltip
        title={t(
          `${buttonType}_analysis_title`,
          buttonType === "cancel"
            ? "Cancel {{type}} analysis"
            : "Anew {{type}} analysis",
          {
            type: t(type),
          }
        )}
      >
        {(type === "project" &&
          ["completed", "failed"].includes(projectData.status)) ||
        (type === "sample" &&
          ["completed", "failed"].includes(sampleData?.status)) ? (
          <IconButton
            aria-label="cancel"
            color="secondary"
            onClick={handleClickOpen}
            className={classes.iconRotate}
          >
            {buttonType === "cancel" ? (
              <BlockIcon fontSize="inherit" />
            ) : (
              <Replay fontSize="inherit" />
            )}
          </IconButton>
        ) : (
          <></>
        )}
      </Tooltip>
      <Dialog
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h4" className="text-bold">
            {t(
              `${buttonType}_analysis_title`,
              buttonType === "cancel"
                ? "Cancel {{type}} analysis"
                : "Anew {{type}} analysis",
              {
                type: t(type),
              }
            )}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="h5">
              {" "}
              {t(
                `${buttonType}_analysis_text`,
                buttonType === "cancel"
                  ? "Are you sure you want to cancel {{type}} analysis? This action cannot be undone!"
                  : "Are you sure you want to anew {{type}} analysis? This action cannot be undone! This project allocate {{credit}} credit.",
                {
                  type: t(type.charAt(0).toUpperCase() + type.slice(1)),
                  credit: creditTopUp.final_price || 0,
                }
              )}
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleClose} color="primary">
            {t("No")}
          </Button>
          <Button
            disabled={loading}
            onClick={buttonType === "cancel" ? handleCanel : handleRe}
            color="primary"
            variant="contained"
          >
            {t("Yes")}
            {loading && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    "&:hover": {
      boxShadow: "0 1px 3px rgba(0,0,0,0.24)",
    },
  },
}))(TableRow);

export const CircularProgressWithLabel = (props) => {
  const classes = useRowStyles();
  return (
    <Box position="relative" display="inline-flex">
      <CircularProgress
        className={classes.analysisProgress}
        size={"35px"}
        thickness={5}
        variant="static"
        {...props}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography
          variant="caption"
          component="div"
          color="textSecondary"
          style={{ fontSize: "11px" }}
        >{`${Math.round(props.value)}%`}</Typography>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    activeSamples: state.activeSamples,
  };
};

const ConnectedSampleRow = (props) => {
  const classes = useRowStyles();
  const [openLog, setOpenLog] = useState(false);
  const [genesAnchorEl, setGenesAnchorEl] = React.useState(null);
  const [hpoAnchorEl, setHpoAnchorEl] = React.useState(null);
  const [openFileTable, setOpenFileTable] = useState(false);
  const { userObj, rowData, projectId, colNames, activeSamples, projectData } =
    props;
  const { t } = useTranslation();
  const status =
    activeSamples[rowData.id] && activeSamples[rowData.id].status
      ? activeSamples[rowData.id].status
      : rowData.status;

  useEffect(() => {
    if (
      rowData.status === "analysing" &&
      rowData.id in activeSamples &&
      activeSamples[rowData.id].status === "completed"
    ) {
      window.location.reload();
    }
  }, [rowData.status, activeSamples]);

  const handleOpenLog = () => {
    setOpenLog((prev) => !prev);
  };

  const hanldeFileTable = () => {
    setOpenFileTable((prev) => !prev);
  };

  const handleGenesClick = (e) => {
    setGenesAnchorEl(e.currentTarget);
  };

  const handleHpoClick = (e) => {
    setHpoAnchorEl(e.currentTarget);
  };

  const handleGenesClose = () => {
    setGenesAnchorEl(null);
  };

  const handleHpoClose = () => {
    setHpoAnchorEl(null);
  };

  return (
    <>
      <StyledTableRow href={"reports/" + rowData.id} hover data-id={rowData.id}>
        <TableCell align="center">
          {userHasPermission(
            userObj.activePermissions,
            "diagnose_analysis"
          ) && (
            <>
              <IconButton onClick={handleOpenLog}>
                {openLog ? <ArrowDown /> : <ArrowUp />}
              </IconButton>
              <Tooltip title={t("Diagnosis Materials")}>
                <IconButton
                  variant=""
                  color="primary"
                  onClick={hanldeFileTable}
                >
                  <File />
                </IconButton>
              </Tooltip>
            </>
          )}
        </TableCell>
        <TableCell component="th" align="center" scope="row">
          {rowData.filename || "N/A"}
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {rowData.name || "N/A"}
        </TableCell>
        <TableCell align="center">
          {rowData.created_at
            ? format(new Date(rowData.created_at), "dd/MM/yyyy")
            : "N/A"}
        </TableCell>
        <TableCell align="center">
          {rowData.started_at
            ? format(new Date(rowData.started_at), "dd/MM/yyyy")
            : "N/A"}
        </TableCell>
        <TableCell
          align="center"
          style={{
            verticalAlign: "middle",
            padding: "8px 16px",
          }}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            position="relative"
          >
            <Box display="flex" alignItems="center">
              {status === "analysing" &&
              ("progress" in rowData || rowData.id in activeSamples) ? (
                <CircularProgressWithLabel
                  value={
                    activeSamples[rowData.id]?.progress ?? rowData.progress
                  }
                />
              ) : (
                <Chip
                  className={clsx(
                    // classes.chip,
                    status === "completed" && classes.completedStatus,
                    status === "analysing" && classes.analyzingStatus,
                    status === "failed" && classes.errorStatus,
                    status === "cancelled" && classes.cancelledStatus,
                    status === "pending" && classes.pendingStatus
                  )}
                  label={t(status)}
                  size="small"
                />
              )}
            </Box>
            {rowData.diagnosis && (
              <Box
                position="absolute"
                right={-17}
                top={2}
                display="flex"
                alignItems="center"
              >
                <Tooltip title={Object.values(rowData.diagnosis)[0] || ""}>
                  <span>
                    {Object.keys(rowData.diagnosis)[0] === "error" ? (
                      <ErrorIcon
                        style={{
                          color: colors.red[300],
                          fontSize: 20,
                          marginRight: -5,
                        }}
                      />
                    ) : (
                      <InfoIcon
                        style={{ color: colors.blue[300], fontSize: 20 }}
                      />
                    )}
                  </span>
                </Tooltip>
              </Box>
            )}
          </Box>
        </TableCell>

        <TableCell>
          {rowData.extras && rowData.extras.genes && (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={handleGenesClick}
              >
                {t("Genes")}
              </Button>
              <Popover
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                anchorEl={genesAnchorEl}
                onClose={handleGenesClose}
                open={Boolean(genesAnchorEl)}
                id={rowData.id}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: 16,
                    padding: 16,
                  }}
                >
                  {rowData.extras.genes.map((gene) => (
                    <Chip label={gene} />
                  ))}
                </Box>
              </Popover>
            </>
          )}
        </TableCell>
        <TableCell>
          {rowData.extras && rowData.extras.hpo_terms && (
            <>
              <Button
                variant="contained"
                color="primary"
                onClick={handleHpoClick}
              >
                {t("Hpo")}
              </Button>
              <Popover
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                anchorEl={hpoAnchorEl}
                onClose={handleHpoClose}
                open={Boolean(hpoAnchorEl)}
                id={rowData.id}
              >
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    gap: 15,
                    padding: 16,
                  }}
                >
                  {rowData.extras &&
                    rowData.extras.hpo_terms &&
                    (typeof rowData.extras.hpo_terms === "string"
                      ? rowData.extras.hpo_terms.split(",")
                      : rowData.extras.hpo_terms
                    )
                      .filter(Boolean)
                      .map((term) => <Chip label={term} />)}
                </Box>
              </Popover>
            </>
          )}
        </TableCell>
        <TableCell>
          {rowData.extras &&
            rowData.extras.assay_type &&
            (rowData.extras.assay_type === "probe"
              ? t("Probe Enrichment Sequencing")
              : t("PCR Amplification Sequencing"))}
        </TableCell>
        <TableCell>
          <Box
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 16,
              padding: 16,
            }}
          >
            <Chip
              label={
                rowData.included_in_frequency
                  ? t("In-activated")
                  : t("De-activated")
              }
              icon={
                rowData.included_in_frequency ? (
                  <CheckCircleOutlineIcon className={classes.chipIcon} />
                ) : (
                  <BlockIcon className={classes.chipIcon} />
                )
              }
              className={
                rowData.included_in_frequency
                  ? classes.successChip
                  : classes.dangerChip
              }
              classes={{
                label: classes.chipLabelWhite,
              }}
              size="small"
              variant="filled"
            />
          </Box>
        </TableCell>

        <TableCell>
          <Box>
            {status === "pending" &&
              userHasPermission(userObj.activePermissions, "cancel_sample") && (
                <CancelAndReAnalysisButton
                  type="sample"
                  buttonType="cancel"
                  sampleData={rowData}
                  projectId={projectId}
                  projectData={projectData}
                />
              )}
            {rowData.download_address && (
              <Tooltip title={t("Download the sample file")}>
                <Link href={`${getBaseURL()}${rowData.download_address}`}>
                  <IconButton>
                    <CloudDownloadIcon color="primary" />
                  </IconButton>
                </Link>
              </Tooltip>
            )}
            {(status === "completed" || status === "failed") &&
              userHasPermission(userObj.activePermissions, "cancel_sample") && (
                <CancelAndReAnalysisButton
                  type="sample"
                  buttonType="re"
                  sampleData={rowData}
                  projectId={projectId}
                  projectData={projectData}
                />
              )}
          </Box>
        </TableCell>
      </StyledTableRow>
      <Dialog
        fullWidth={true}
        maxWidth="lg"
        open={openFileTable}
        onClose={hanldeFileTable}
      >
        <DiagnosisMaterialsTable t={t} rowData={rowData} />
      </Dialog>
      {openLog && (
        <TableRow>
          <TableCell colSpan={colNames.length}>
            <Collapse in={openLog}>
              <FailLogs
                id={rowData.id}
                isFailed={rowData.status === "failed"}
              />
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

const SampleRow = connect(mapStateToProps)(ConnectedSampleRow);

const useFilesTableStyle = makeStyles((theme) => ({
  tableRow: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  tableContainer: {
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden",
    border: `1px solid ${theme.palette.divider}`,
  },
  boldCell: {
    fontWeight: "bold",
  },
  tableHeaderBackground: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  firstHeaderCell: {
    borderTopLeftRadius: theme.shape.borderRadius,
  },
  lastHeaderCell: {
    borderTopRightRadius: theme.shape.borderRadius,
  },
  tableHead: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: 14,
  },
  sampleTableHead: {
    backgroundColor: theme.palette.secondary.main,
  },
  pointer: {
    cursor: "pointer",
  },
}));

const importantFileTags = [
  "bam",
  "bai",
  "vcf",
  "vcf_idx",
  "variant_table_report",
];

const isImportantFile = (tags = []) =>
  tags.some((tag) => importantFileTags.includes(tag));

const FilesTable = (props) => {
  const { files } = props;
  const classes = useFilesTableStyle();
  const { t } = useTranslation();

  const fileEntries = Object.entries(files);

  const prioritizedFiles = fileEntries.sort(([, file1], [, file2]) => {
    const file1IsImportant = isImportantFile(file1.tags);
    const file2IsImportant = isImportantFile(file2.tags);
    return file2IsImportant - file1IsImportant;
  });

  return (
    <Table size="small" align="center" aria-label="samples">
      <TableHead>
        <TableRow>
          <TableCell
            className={`${classes.tableHeaderBackground} ${classes.firstHeaderCell}`}
          >
            {t("File Name")}
          </TableCell>
          <TableCell
            className={`${classes.tableHeaderBackground}`}
            align="center"
          >
            {t("Download Link")}
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {prioritizedFiles.map(([key, file], index) => (
          <TableRow key={index} className={classes.tableRow}>
            <TableCell
              className={clsx({
                [classes.boldCell]: isImportantFile(file.tags),
              })}
            >
              {file.name}
            </TableCell>
            <TableCell>
              <Link
                href={`${getBaseURL()}${file.download_address}`}
                className={classes.downloadLink}
              >
                <Box display="flex" alignItems="center" justifyContent="center">
                  {t("DOWNLOAD")}
                  <GetAppIcon style={{ fontSize: "1.5rem" }} />
                </Box>
              </Link>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

const ReportRow = (props) => {
  const { rowData, setSelectedRowId, projectData } = props;
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [IGVFiles, setIGVFiles] = useState(undefined);
  const classes = useRowStyles();
  const { t } = useTranslation();

  useEffect(() => {
    setIGVFiles(prepareFiles(rowData.files, rowData.unified_output));
  }, []);

  const handleDetailsClick = (event) => {
    event.stopPropagation();
    setDetailsOpen(!detailsOpen);
  };

  const handleClick = () => {
    setSelectedRowId(rowData.id);
  };

  const openIGV = (event) => {
    event.stopPropagation();
    let igvTracks = "";
    const sendRequest = (file) => {
      fetch(`http://localhost:60151/load?genome=${projectData.genome}&${file}`)
        .then((response) => {
          safeLogger(response);
        })
        .catch((error) => {
          setOpenDialog(true);
        });
    };

    if (IGVFiles["mutect2_bam"] && IGVFiles["mutect2_bai"]) {
      igvTracks += `&file=${getBaseURL()}${
        IGVFiles["mutect2_bam"].download_address
      }&index=${getBaseURL()}${IGVFiles["mutect2_bai"].download_address}`;
      sendRequest(igvTracks);
    }

    if (IGVFiles["bam"] && IGVFiles["bai"]) {
      igvTracks = `&file=${getBaseURL()}${
        IGVFiles["bam"].download_address
      }&index=${getBaseURL()}${IGVFiles["bai"].download_address}`;
      sendRequest(igvTracks);
    }

    if (IGVFiles["haplotypecaller_bam"] && IGVFiles["haplotypecaller_bai"]) {
      igvTracks = `&file=${getBaseURL()}${
        IGVFiles["haplotypecaller_bam"].download_address
      }&index=${getBaseURL()}${
        IGVFiles["haplotypecaller_bai"].download_address
      }`;
      sendRequest(igvTracks);
    }

    if (IGVFiles["sample1_bam"] && IGVFiles["sample1_bai"]) {
      igvTracks = `&file=${getBaseURL()}${
        IGVFiles["sample1_bam"].download_address
      }&index=${getBaseURL()}${IGVFiles["sample1_bai"].download_address}`;
      sendRequest(igvTracks);
    }

    if (IGVFiles["sample2_bam"] && IGVFiles["sample2_bai"]) {
      igvTracks = `&file=${getBaseURL()}${
        IGVFiles["sample2_bam"].download_address
      }&index=${getBaseURL()}${IGVFiles["sample2_bai"].download_address}`;
      sendRequest(igvTracks);
    }

    if (IGVFiles["vcf"] && IGVFiles["vcf_idx"]) {
      igvTracks = `&file=${getBaseURL()}${
        IGVFiles["vcf"].download_address
      }&index=${getBaseURL()}${IGVFiles["vcf_idx"].download_address}`;
      sendRequest(igvTracks);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <React.Fragment>
      <StyledTableRow
        hover
        className={classes.row}
        data-id={rowData.id}
        onClick={handleClick}
      >
        <TableCell align="center">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={handleDetailsClick}
          >
            {detailsOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" align="center">
          {rowData.name || "N/A"}
        </TableCell>

        <TableCell align="center" style={{ verticalAlign: "middle" }}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
            style={{ minHeight: "100%", gap: 2 }}
          >
            <Tooltip title={t("Show variant analysis")}>
              <RouterLink to={`/reports/${rowData.id}`}>
                <IconButton>
                  <TableChartIcon color="primary" />
                </IconButton>
              </RouterLink>
            </Tooltip>
            {IGVFiles && IGVFiles["auto_report"] && (
              <Tooltip title={t("Download PDF")}>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  target="_blank"
                  href={getBaseURL() + IGVFiles["auto_report"].download_address}
                >
                  <PictureAsPdf color="primary" />
                </IconButton>
              </Tooltip>
            )}
            {IGVFiles &&
              ((IGVFiles["bam"] && IGVFiles["bai"]) ||
                (IGVFiles["mutect2_bam"] && IGVFiles["mutect2_bai"]) ||
                (IGVFiles["haplotypecaller_bam"] &&
                  IGVFiles["haplotypecaller_bai"]) ||
                (IGVFiles["sample1_bam"] && IGVFiles["sample1_bai"]) ||
                (IGVFiles["vcf"] && IGVFiles["vcf_idx"])) && (
                <Tooltip title={t("Open in IGV")}>
                  <Box
                    onClick={openIGV}
                    display="flex"
                    alignItems="center"
                    height="100%"
                    style={{ cursor: "pointer", paddingLeft: 3 }}
                  >
                    <img
                      alt="igv logo"
                      height="16"
                      src="/assets/images/icons/IGV.svg"
                      style={{ marginRight: 4 }}
                    />
                    <OpenInNewIcon fontSize="small" />
                  </Box>
                </Tooltip>
              )}
          </Box>
        </TableCell>
        <TableCell align="center">
          {rowData.generated_at
            ? format(new Date(rowData.generated_at), "dd/MM/yyyy")
            : "N/A"}
        </TableCell>
        <TableCell onClick={(e) => e.stopPropagation()}>
          <Status
            data={rowData.status_choices}
            value={rowData.evaluation}
            id={rowData.id}
          />
        </TableCell>
        {/* <TableCell style={{ maxWidth: 200 }}>
          <Tooltip title="Add" aria-label="add">
            <Box display="flex" justifyContent="center" alignItems="center">
              <InfoIcon className={classes.info} />
            </Box>
          </Tooltip>
        </TableCell> */}
      </StyledTableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={detailsOpen} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography
                variant="h4"
                style={{
                  margin: "10px auto",
                  fontWeight: "bold",
                  paddingTop: "15px",
                  paddingBottom: "10px",
                }}
              >
                {t("Analysis Outputs")}
              </Typography>
              <FilesTable files={rowData.files} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("Unable to open sample in IGV")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t(
              "Sample could not be opened in IGV. Please make sure IGV is installed and running. If the problem persists, please contact support."
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            {t("Close")}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export const DetailsTable = (props) => {
  const {
    userObj,
    classes,
    tableType,
    colNames,
    reports,
    projectData,
    sort,
    setSort,
    setSelectedRowId,
  } = props;

  const handleSort = (name, isSorting) => {
    if (isSorting) {
      setSort((prev) => {
        const newSort = {
          [name]:
            sort[name] === "ASC" ? "DESC" : sort[name] === "DESC" ? "" : "ASC",
        };
        if (newSort[name] === "") {
          delete newSort[name];
        }
        return newSort;
      });
    }
  };

  return (
    <TableContainer component={Paper} className={classes.tableFixHeader}>
      <Table
        align="center"
        size="small"
        stickyHeader
        aria-label="variant table"
        id="variant-table"
      >
        <TableHead className={classes.tableFixHeader}>
          <TableRow align="center">
            {colNames.map((item, index) => (
              <TableCell
                key={index}
                onClick={() => handleSort(item.name, item.sort)}
                className={clsx(classes.tableHead, {
                  [classes.sampleTableHead]: tableType === "samples",
                  [classes.pointer]: item.sort,
                })}
                align="center"
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  color={"white"}
                  gap={8}
                  style={{ minHeight: 40 }}
                >
                  {item.label}
                  {item.sort ? (
                    sort[item.name] === "ASC" ? (
                      <ArrowUp />
                    ) : sort[item.name] === "DESC" ? (
                      <ArrowDown />
                    ) : (
                      ""
                    )
                  ) : (
                    ""
                  )}
                </Box>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {tableType === "samples" &&
            projectData.samples &&
            projectData.samples.map((rowData, index) => (
              <SampleRow
                userObj={userObj}
                key={index}
                colNames={colNames}
                rowData={rowData}
                projectData={projectData}
                projectId={projectData.id}
              />
            ))}
          {tableType === "reports" &&
            reports &&
            reports.map((rowData, index) => (
              <ReportRow
                projectData={{ reports, ...projectData }}
                key={index}
                rowData={rowData}
                setSelectedRowId={setSelectedRowId}
              />
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
